<template>
 <v-app>
  <div id="app">
    <router-view/>
  </div>
   </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.v-application a {
    color: unset!important;
}
.v-application a:hover {
    color:#86c1f2!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue